
// ThirdSection.js - Modern Blog Section
import React, { useState, useEffect } from "react";
import CardSlider from "../../cardSlider/CardSlider";
import BlogCard from "../../blogCard/BlogCard";
import { fetchData } from "../../../Utils/CommonFunctions";

function ThirdSection() {
  const [latestBlogData, setLatestBlogData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      try {
        setLoading(true);
        const response = await fetchData(`https://app.akiya2.com/blogs`);

        const sortedData = response
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 5);

        setLatestBlogData(sortedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#10c9c0]"></div>
      </div>
    );
  }

  if (latestBlogData.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <p className="text-gray-500 text-lg">No blog posts available</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {/* Header */}
      <div className="text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">Latest Blog Posts</h3>
        <p className="text-base md:text-lg font-light text-[#949995]">Discover more about our properties and destinations</p>
      </div>
      
      {/* Blog Cards */}
      <div className="bg-gradient-to-r from-gray-50 to-white rounded-2xl p-0">
        <CardSlider
          data={latestBlogData}
          Card={BlogCard}
          endValues={{
            xs: 1,
            sm: 1,
            md: 2,
            lg: 3,
          }}
        />
      </div>
    </div>
  );
}

export default ThirdSection;
